import { Component, OnInit, Injector, Input, Output, EventEmitter } from '@angular/core';
import { MedicationRequestService } from 'app/core/http/services/medicationrequest.service';
import { Medications, Prescription } from 'app/core/interfaces/prescriptions';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import * as moment from 'moment';

@Component({
  selector: 'page-create-prescription',
  templateUrl: './create-prescription.html',
  styleUrls: ['./create-prescription.scss'],
})
export class CreatePrescription extends BaseComponent implements OnInit {
  @Input() public encounter_id: string = '';
  @Input() public patient_id: string = '';
  @Input() public medications: Medications[] = [];
  @Output() onUpdate = new EventEmitter();
  @Input() mode = 'CREATE';

  public titleMedications = 'Medicamentos';
  public prescription: Prescription[] = [];
  public medicationrequest_id: string = '';

  constructor(private injector: Injector, private medicationRequest: MedicationRequestService) {
    super(injector);
  }

  ngOnInit(): void {
    this.createOrUpdate();
  }

  private getEncounterPrescriptions() {
    this.medicationRequest.showByEncounter(this.encounter_id).subscribe({
      next: (prescription: any) => {
        this.prescription = prescription[0];
        this.medications = prescription[0].prescriptions;
        this.medicationrequest_id = prescription[0].medicationrequest_id;
        this.mode = 'UPDATE';
      },
      error: (err) => {
        console.log(err);
        this.mode = 'CREATE';
      },
    });
  }

  addPrescription() {
    if (!this.medications) {
      this.medications = [];
    }

    this.medications.push({
      medicationName: '',
      medicationType: '',
      dosage: '',
      use: '',
      recommendation: '',
    });
  }

  onChangeForm() {
    const retorno: any = {
      medications: this.medications,
    };
    this.onUpdate.emit(retorno);
  }

  create() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    const prescriptionsFormValues: Prescription = {
      encounter_id: this.encounter_id,
      requestedFor: this.patient_id,
      requestedBy: this.getUserLogged().id,
      requestedDate: moment().format(),
      prescriptions: this.medications,
    };

    this.medicationRequest.create(prescriptionsFormValues).subscribe({
      next: (resMedication: any) => {
        this.showSuccessMessage = true;

        this.getEncounterPrescriptions();
      },
      error: (err) => {
        this.showSuccessMessage = false;
        this.showErrorMessage = true;

        console.log(err);
      },
    });
  }

  save() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    const prescriptionsFormValues: any = {
      ...this.medications,
      ...this.prescription,
    };

    this.medicationRequest.update(this.medicationrequest_id, prescriptionsFormValues).subscribe({
      next: (resMedication: any) => {
        this.showSuccessMessage = true;
      },
      error: (err) => {
        this.showSuccessMessage = false;
        this.showErrorMessage = true;
        console.log(err);
      },
    });
  }

  createOrUpdate() {
    this.getEncounterPrescriptions();
  }
}
